const SocialProfileCollection = Backbone.Collection.extend({
  name: 'contact',

  initialize() {
    this.xhr = null;
  },
  abort() {
    if (this.xhr) {
      this.xhr.abort();
    }
  },
  saveCache(key, profiles) {
    const cache = new Cache();
    cache.store(key, JSON.stringify(profiles), 45);
  },
  readCache(key) {
    const cache = new Cache();
    if (cache.read(key)) {
      const result = JSON.parse(cache.read(key));
      return result;
    }
    return [];
  },
  addProfile(profile, key) {
    const profileList = this.readCache(key);
    if (!_.contains(_.pluck(profileList, 'username'), profile.username)) {
      profileList.push(profile);
    }
    this.saveCache(key, profileList);
    return profileList;
  },
  sync(method, collection, options) {
    // Possible methods: create, read, update, dete
    // eslint-disable-next-line
    const $username = loginContext.getCurrentDetails().username;
    const _this = this;
    const defer = $.Deferred();

    options.reset = (options.reset === undefined ? true : options.reset);

    if (method == 'read') {
      const params = {
        type: options.type,
        account_id: options.account_id,
        q: options.query,
      };

      _this.xhr = Sendible.Connect.socialProfileSearch(
        window.appConfig.applicationId,
        params,
        (data) => {
          if (typeof data.profiles === 'undefined') {
            data.profiles = data;
          }

          if (data.account_id) {
            _this.account_id = data.account_id;
          }

          options.success(data.profiles);
          defer.resolve(data.profiles);
        },
        (data) => {
          options.error(data);
          defer.reject(data);
        },
        params,
      );
    }
    const promise = defer.promise();
    return promise;
  },

  parse(data) {
    return data;
  },
});

export default SocialProfileCollection;
